import { addNavMenuItem, Permission, registerCustomDetailComponent, registerFormInputComponent } from '@vendure/admin-ui/core';
import { SellerStoreSiteDetailComponent } from './components/seller-store-site-detail/seller-store-site-detail.component';
import { RelationStoreSiteDisplayComponent } from './components/relation-store-site-display.component';
import { PolicyContentFormComponent } from './components/policy-content-form.component';
import { ColorConfigFormComponent } from './components/color-config-form.component';
import { SnsInfoFormComponent } from './components/sns-info-form-component';
import { allow } from '../common/ui/utils';

export default [
    registerCustomDetailComponent({locationId: 'seller-detail',
        component: SellerStoreSiteDetailComponent
    }),
    registerFormInputComponent('relation-store-site-display', RelationStoreSiteDisplayComponent),
    registerFormInputComponent('policy-content-form', PolicyContentFormComponent),
    registerFormInputComponent('color-config-form', ColorConfigFormComponent),
    registerFormInputComponent('sns-info-form', SnsInfoFormComponent),
    addNavMenuItem({
        requiresPermission: allow(Permission.SuperAdmin),
        id: 'site-component',
        label: 'Site Components',
        routerLink: ['/store-settings', 'site-component'],
        icon: 'store',

    },
    'store-settings',
    'parcel-profiles'),
];
